import { render, staticRenderFns } from "./RoomDamageQuestion.vue?vue&type=template&id=02c39a48&scoped=true"
import script from "./RoomDamageQuestion.vue?vue&type=script&lang=ts"
export * from "./RoomDamageQuestion.vue?vue&type=script&lang=ts"
import style0 from "./RoomDamageQuestion.vue?vue&type=style&index=0&id=02c39a48&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02c39a48",
  null
  
)

export default component.exports